import { useTranslation } from "@refinedev/core";

import { Button, Paper, Stack, Typography } from "@mui/material";

export interface DeactivateValidationDialogProps {
  open: boolean;
  onClose: () => void;
}

export const DeactivateValidationDialog = ({ open, onClose }: DeactivateValidationDialogProps) => {
  const { translate } = useTranslation();

  if (!open) {
    return null;
  }

  const prefix = "pages.practitioner.editModal.deactivateValidation";

  const title = translate(`${prefix}.title`);
  const message = translate(`${prefix}.message`);
  const goBackLabel = translate(`${prefix}.goBack`);

  return (
    <Paper elevation={0} variant="alertWarning" data-testid="deactivate-validation-dialog">
      <Stack spacing={2} alignItems="center">
        <Typography variant="h3" textAlign="center" color="text.primary">
          {title}
        </Typography>

        <Typography variant="body2" textAlign="center" color="text.primary">
          {message}
        </Typography>

        <Button
          variant="outlined"
          color="warning"
          onClick={onClose}
          data-testid="deactivate-validation-dialog-close"
          autoFocus
        >
          {goBackLabel}
        </Button>
      </Stack>
    </Paper>
  );
};
